import { render, staticRenderFns } from "./yek-asiakirjat.vue?vue&type=template&id=3c63ffcf&scoped=true&"
import script from "./yek-asiakirjat.vue?vue&type=script&lang=ts&"
export * from "./yek-asiakirjat.vue?vue&type=script&lang=ts&"
import style0 from "./yek-asiakirjat.vue?vue&type=style&index=0&id=3c63ffcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63ffcf",
  null
  
)

export default component.exports